import React from "react";
import { Col, Row } from "antd";
import { Link, useLocation } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";

const FeedBackMenu: React.FC = () => {
  const location = useLocation();
  const botHandle = location.pathname.split("/")[3];

  const title = botHandle ? botHandle : "FEEDBACK";

  return (
    <Row className="menu" align="middle">
      {botHandle &&
        <Link to="/feedback/dashboard">
          <LeftOutlined style={{ marginBottom: 5, color: "#287cd0" }} />
        </Link>}
      <Col style={{ marginLeft: 5 }} className="title">
        {title}
      </Col>
    </Row>
  );
};

export default FeedBackMenu;
